module.exports = __webpack_public_path__ + "e30823920fe7f8d820b5a80e54c30c84.ttf";